import { HttpHeaders } from '@angular/common/http';
import { environment } from '@env';

export function generateAuthenticationHeader(token: string): HttpHeaders {
  return new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Ocp-Apim-Subscription-Key': environment.subscriptionKey,
  });
}
